module.exports = require("@angular/platform-browser/animations");